<template>
    <ui-link v-if="to" :post_link="to" class="link" :class="classname">
        <slot></slot>
    </ui-link>
    <span v-else :class="classname" class="no-link">
        <slot></slot>
    </span>
</template>

<script>

export default {
    name: 'ui-button',

    props: {
        to: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'base',
        },
        color: {
            type: String,
            default: 'grey',
        },
    },

    data() {
        return {
            classname: ['ui-button'],
        }
    },


    mounted() {
        this.classname.push('size-' + this.size);
        this.classname.push('color-' + this.color);
    },
}

</script>

<style lang="scss">
    .ui-button {
        display: inline-block;
        cursor: pointer;
        box-sizing: border-box;
        font-weight: normal;
        border: 1px solid var(--font-color);
        transition: all .2s ease;
        text-transform: uppercase;

        &:hover {
            background-color: var(--font-color);
            color: white;
        }

        &.size-large {
            line-height: 3rem;
            height: 3rem;
            padding: 1rem 1.5rem;
            font-size: var(--large-size);
        }

        &.size-base {
            font-size: var(--base-size);
            line-height: 1;
            padding: var(--padding-50) var(--padding);
            
            &.type-border {
                line-height: 1;
            }
        }
        
        &.size-medium {
            font-size: var(--medium-size);
            line-height: 1;
            padding: 1.05rem 1.85rem;
            border-radius: 3rem;
            
            &.type-border {
                line-height: 1;
            }
        }

        &.size-small {
            $size: 2.4rem;
            line-height: 1;
            height: $size;
            padding: 0.333rem .75rem;
            font-size: var(--small-size);
        }


        // &.type-border.color-black {
        //     color: var(--black);
        //     background-color: transparent;

        //     &.link:hover {
        //         color: var(--white);
        //         background-color: var(--black);
        //         border-color: var(--black);
        //         opacity: 1;
        //     }
        // }

        // &.type-border.color-grey {
        //     color: var(--font-color);
        //     background-color: transparent;

        //     &:hover {
        //         color: var(--white);
        //         background-color: var(--black);
        //         border-color: var(--black);
        //         opacity: 1;
        //     }
        // }

        
        &.type-bg.color-theme-2 {
            color: var(--font-color);
            background: var(--theme-2);

            &.link:hover {
                color: var(--white);
                background-color: var(--black);
                border-color: var(--black);
                opacity: 1;
            }
        }

        // &.type-bg.color-red {
        //     color: var(--font-color);
        //     background: var(--pink);

        //     &.link:hover {
        //         color: var(--white);
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-blue {
        //     color: var(--font-color);
        //     background: var(--blue);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-orange {
        //     color: white;
        //     background: var(--orange);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }


        &.only-text {
            border-color: transparent !important;
            background-color: transparent !important;
            cursor: default;
        }



    }

    // @media only screen and (max-width: 767px) {
    //     .ui-button {

    //         // &.size-base {
    //         //     font-size: var(--base-size);
    //         //     line-height: 1.2;
    //         //     padding: var(--padding-25) var(--padding-x2);
                
    //         //     &.type-border {
    //         //         line-height: 1;
    //         //     }
    //         // }

    //         &.size-small {
    //             $size: 4.4rem;
    //             height: $size;
    //         }

          


    //     }

    // }
</style>